import { update } from 'modules/immutable';
import { useSelector } from 'modules/react-redux';
import { useCallback } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { getExpandedColumnsInScope, isCustomField } from '../../../../selectors/reportConfigSelectors';
import { ReportConfigColumn } from '../../../../types/ReportConfigColumn';
import { SectionVisibleColumnsProps } from './SectionVisibleColumns.types';

export const useSectionVisibleColumns = (
    reportConfig: SectionVisibleColumnsProps['reportConfig'],
    onReportConfigChange: SectionVisibleColumnsProps['onReportConfigChange']
) => {
    const company = useCompanyBasedOnUrl();
    const expandedColumns = useSelector((state) => getExpandedColumnsInScope(state, reportConfig));

    const handleToggleColumnVisibility = useCallback(
        (column: ReportConfigColumn) => {
            const newReportConfig = update(reportConfig, 'columns', (columnsConfigs) => {
                return isCustomField(column.kind)
                    ? columnsConfigs.map((config) =>
                          config.id === column.id ? { ...config, visible: !config.visible } : config
                      )
                    : columnsConfigs.map((config) =>
                          config.kind === column.kind ? { ...config, visible: !config.visible } : config
                      );
            });

            onReportConfigChange(newReportConfig);
        },
        [onReportConfigChange, reportConfig]
    );

    return {
        company,
        expandedColumns,
        handleToggleColumnVisibility,
    };
};
